import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Avatar } from '@mui/material';
export default function FormAvatar(props) {
    var children = props.children, rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Avatar, rest, children);
}
